// Locate the actual tapped word without inserting spans or changing book layout.
export function wordAtPoint(block,x,y){
  const walker=block.ownerDocument.createTreeWalker(block,NodeFilter.SHOW_TEXT);
  let node,offset=0;
  while((node=walker.nextNode())){
    for(const match of node.textContent.matchAll(/\S+/gu)){
      const range=block.ownerDocument.createRange();range.setStart(node,match.index);range.setEnd(node,match.index+match[0].length);
      if([...range.getClientRects()].some(r=>x>=r.left&&x<=r.right&&y>=r.top&&y<=r.bottom))return {offset:offset+match.index,word:match[0]};
    }
    offset+=node.textContent.length;
  }
  return null;
}

// Timestamp policy is shared with Elm; DOM hit testing and Intl stay native.
export async function timestampFor(target,timings=[]){
  const {policy}=await import('./policy.js');
  return (await policy('timestamp',{target:{blockId:target.blockId,offset:target.offset},timings}))??undefined;
}

// Boundaries are UTF-16 offsets, matching speech events and recording timestamps.
export function sentenceStarts(text,language='en'){
  let segments;
  if(typeof Intl.Segmenter==='function'){
    let segmenter;try{segmenter=new Intl.Segmenter(language,{granularity:'sentence'});}catch{segmenter=new Intl.Segmenter('en',{granularity:'sentence'});}
    segments=[...segmenter.segment(text)].map(({segment,index})=>({text:segment,index}));
  }else segments=[...text.matchAll(/[^.!?。！？]+(?:[.!?。！？]+[”’"']*|$)/gu)].map(match=>({text:match[0],index:match.index}));
  return segments.filter(segment=>segment.text.trim()).map(segment=>segment.index+segment.text.search(/\S/u));
}
